module.exports = __webpack_public_path__ + "img/icon-payment-creditcard.9e9a5b60.png";